import { useState, useEffect, memo } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { useApp } from '../../context/AppContext';
import { PageUserEdit } from './PageUserEdit';
import * as api from '../../services/api';

export const PageUserEditRoute = memo(() => {
  const { showToast } = useApp();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const profileId = searchParams.get('id');

  const [loading, setLoading] = useState(true);
  const [member, setMember] = useState(null);

  useEffect(() => {
    if (!profileId) { navigate('/team/users'); return; }
    (async () => {
      setLoading(true);
      try {
        // Fetch profile + manage data (includes platforms/links)
        const [profileRes, manageRes] = await Promise.all([
          api.getMemberById(profileId),
          api.getMemberManage(profileId),
        ]);
        const profile = profileRes.data || profileRes;
        const manage = manageRes.data || manageRes;

        // Merge existing links from manage into profile
        const platforms = manage.platforms || [];
        profile.existingLinks = platforms.map((p, i) => ({
          id: p.id,
          type: p.title,
          label: p.label || p.title,
          ico: p.icon || null,
          color: '#64748b',
          url: p.path || '',
          platformId: p.platform_id,
          baseUrl: p.baseUrl || '',
          input: p.input || 'url',
          placeholder: p.placeholder || '',
          description: p.description || '',
          order: p.platform_order ?? i,
          docFile: null,
        }));

        setMember(profile);
      } catch (e) {
        showToast(e.message || "Failed to load profile", "error");
        navigate('/team/users');
      } finally { setLoading(false); }
    })();
  }, [profileId]);

  if (loading) return <div className="pg fi"><div style={{ padding: 60, textAlign: "center", color: "var(--t3)", fontSize: 14 }}>Loading profile...</div></div>;
  if (!member) return null;

  return (
    <PageUserEdit
      member={member}
      onBack={() => navigate('/team/users')}
      onToast={showToast}
    />
  );
});
